export default {"src":"/_next/static/media/SMCI.c787e362.svg","height":18,"width":18};